import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { I1DataUploadTable } from "./table";
import { I1DataUploadEdit } from "./edit";

export default function I1DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<I1DataUploadEdit />} />
      <Route index element={<I1DataUploadTable />} />
    </Routes>
  );
}
